import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import AuthUtils from '@/utils/AuthUtils';
import routes from './routes';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
});

// routes is an array of functions that return routes
routes.forEach((func) => router.addRoutes(func(router)));

router.afterEach(async (to, from) => {
  // WARNING: this only triggers if the route actually changes, manually set the loading to false if the route is the same
  router.app.$loading(false);
});

router.beforeEach(async (to, from, next) => {
  router.app.$loading(true); // set a loading spinner for when the page component needs to load

  if (!router.app.$session) {
    try {
      await AuthUtils.init();
    } catch (error) {
      console.error('session init', error);
    }
  }

  let redirect: string | undefined = undefined;
  if (to.meta.auth === false) {
    // auth not required to view page
  } else if (!router.app.$session && to.name !== 'login') {
    redirect = 'login';
  } else if (!router.app.$session.role && to.name !== 'role-select') {
    redirect = 'role-select';
  } else if (
    router.app.$session.state === 'reset_password' &&
    router.app.$session.role &&
    to.name !== 'password-reset'
  ) {
    redirect = 'password-reset';
  }

  if (redirect) {
    if (redirect === from.name) {
      // this is needed as afterEach() will not be called unless the route actually changes causing an infinite spinner
      router.app.$loading(false);
    }
    next({ name: redirect });
  } else {
    next();
  }
});

export default router;
